import React from "react";

/**
 * Font size buttons component
 */
const FontSizeButtons = ({ currentSize, onSizeChange }) => {
  const sizes = ["small", "medium", "big"];

  return (
    <div
      style={{
        background: "#f5f5f5",
        borderRadius: "8px",
        padding: "10px 12px",
        marginBottom: "12px",
      }}
    >
      <label style={{ display: "block", marginBottom: "4px" }}>Font Size</label>
      <div style={{ display: "flex", gap: "8px" }}>
        {sizes.map((size) => (
          <button
            key={size}
            onClick={() => onSizeChange(size)}
            style={{
              padding: "6px 12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: currentSize === size ? "#0056b3" : "white",
              color: currentSize === size ? "white" : "#333",
              cursor: "pointer",
            }}
          >
            {size.charAt(0).toUpperCase() + size.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FontSizeButtons;
